//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      text: 'some text'
    };
  },
  methods: {
    handleAdd: function handleAdd() {
      this.$log.push(this.text);
    }
  }
};